// Адрес API. В образе — путь /API/V1 без домена (client/Dockerfile): API на
// том же домене, что и страница. В разработке — http://localhost:3000.
// Без косой в конце: код дописывает пути с ведущей косой
// ('/auth/refresh'). С косой в конце получалось /API/V1//auth/refresh, и
// браузер не отправлял туда куку refresh_token с путём /API/V1/auth —
// сессия не обновлялась (2026-11-03)
export default {
    baseURL: (process.env.VUE_APP_BASE_URL || 'http://localhost:3000').replace(/\/+$/, '')
}
